import { getOpacity as getGlobalOpacity } from './opacity.global';
import { INTERACTION_STATE_ACTIVE, INTERACTION_STATE_HOVER } from '../constants';
export function getOpacity(transformer) {
    const globalOpacity = getGlobalOpacity(transformer);
    return Object.freeze({
        backdrop: { value: globalOpacity.pointSeven },
        attentionBlock: {
            interactionStates: {
                [INTERACTION_STATE_HOVER]: { value: globalOpacity.pointFive },
                [INTERACTION_STATE_ACTIVE]: { value: globalOpacity.pointFive },
            },
        },
    });
}
